import { IUserBff } from '@/api/UserBff';
import { Module } from 'vuex';
import { RootState } from '../types';
import { createActions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import { UserState } from './types';

export const state: UserState = {
  currentUser: null,
  isLoggedIn: false,
  isEmailVerified: false,
  error: false,
  firebaseIdToken: null
};

export function create(userBff: IUserBff): Module<UserState, RootState> {
  const actions = createActions(userBff);
  return {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  } as Module<UserState, RootState>;
}

export const name = 'userModule';
